module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/active-call-40880ea2717d43834c054976256dd989.svg";